import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppRoutes from './AppRoutes';
import {
  FacilityUnitProvider,
  LoadingProvider,
  FeedbackProvider,
  FeatureFlagsProvider,
} from './context';
import GlobalLoadingIndicator from './components/common/GlobalLoadingIndicator';
import AppInitializer from './components/common/AppInitializer';
import { FeedbackModal, ToastFeedbackNotification } from './components/common/Feedback';

// Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <FeatureFlagsProvider>
        <AppInitializer>
          <Router basename={process.env.REACT_APP_BASENAME || ''}>
            <LoadingProvider>
              <GlobalLoadingIndicator />
              <FacilityUnitProvider>
                <FeedbackProvider>
                  <ToastFeedbackNotification />
                  <FeedbackModal />
                  <div className="flex w-full">
                    <div className="w-full flex items-center justify-center">
                      <AppRoutes />
                    </div>
                  </div>
                </FeedbackProvider>
              </FacilityUnitProvider>
            </LoadingProvider>
          </Router>
        </AppInitializer>
      </FeatureFlagsProvider>
    </QueryClientProvider>
  );
}

export default App;
